import React from 'react';
import Wordmark from '../Brand/Wordmark';

// Shared chrome for both sign-in steps, ported from the Claude Design file
// "Agent Console Sign-in.dc.html" (project 53fe2c35…, 2026-09-17): a brand
// panel on the left, the sign-in column on the right, one column below 760px.
//
// The mock's stat row (71% / 2:08 / 4.6) is deliberately absent: those were
// placeholder figures, and this page is reachable without signing in. Add a
// row back only with numbers read from real reporting.
//
// Step 1 is the Cognito console login (LoginGate), step 2 is Amazon Connect
// (LoggedOut). Styles live in styles/login.css.

export default function SignInScreen({
  statusText,
  title,
  subtitle,
  error,
  children,
  step,          // { label, pct, body }
  footNote,
}) {
  return (
    <div className="sg-root">
      <div className="sg-grid">

        {/* ── Brand side ─────────────────────────────────────── */}
        <section className="sg-brand">
          <div className="sg-orb sg-orb-a" aria-hidden="true" />
          <div className="sg-orb sg-orb-b" aria-hidden="true" />
          <div className="sg-mesh" aria-hidden="true" />

          <div className="sg-mark">
            <Wordmark />
            <span className="sg-chip">AGENT DESKTOP</span>
          </div>

          <div className="sg-pitch">
            <h1 className="sg-headline">The call arrives<br />already understood.</h1>
            <p className="sg-blurb">
              Every handover comes with the caller&apos;s history, what the AI
              already did, and what it promised — so nobody has to start over.
            </p>
          </div>

        </section>

        {/* ── Sign-in side ───────────────────────────────────── */}
        <section className="sg-panel">
          <div className="sg-form">
            <div className="sg-status">
              <span className="sg-dot" aria-hidden="true" />
              <span className="sg-status-text">{statusText}</span>
              <span className="sg-host">{window.location.host}</span>
            </div>

            <h2 className="sg-title">{title}</h2>
            <p className="sg-sub">{subtitle}</p>

            {error && <p className="sg-error" role="alert">{error}</p>}

            <div className="sg-actions">{children}</div>

            {step && (
              <div className="sg-note">
                <div className="sg-note-head">
                  <span className="sg-step">{step.label}</span>
                  <span className="sg-bar"><i style={{ width: `${step.pct}%` }} /></span>
                </div>
                <div className="sg-note-body">{step.body}</div>
              </div>
            )}

            <div className="sg-foot">
              <span>{footNote}</span>
              <a href="mailto:admin@knktr.ai?subject=Console%20sign-in%20help">Get help signing in</a>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
}
